import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  zIndex?: string;
  /** Mobilde bottom-sheet gibi aşağıdan açılır, tam yükseklik alır. */
  bottomSheet?: boolean;
  /** Parent container'ı içinde absolute konumla render eder (portal kullanmaz).
   *  Parent'ın `position: relative` ve yeterli boyuta sahip olması gerekir. */
  inline?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = '',
  zIndex = 'z-[60]',
  bottomSheet = false,
  inline = false,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const positioning = inline ? 'absolute' : 'fixed';

  // Ortalamayı items-center yerine çocuğun auto margin'i ile yapıyoruz: içerik ekrandan uzun olduğunda
  // items-center üst kısmı ekran dışına taşırıp erişilemez kılıyor; auto margin + overflow-y-auto ile kaydırılabiliyor.
  const alignmentClasses = bottomSheet
    ? 'items-end justify-center sm:items-center sm:p-4'
    : 'overflow-y-auto overscroll-contain p-4 pb-20 md:pb-4 [&>*]:m-auto';

  const content = (
    <div
      className={`${positioning} inset-0 bg-black bg-opacity-50 flex ${alignmentClasses} ${zIndex} ${className}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      {children}
    </div>
  );

  return inline ? content : createPortal(content, document.body);
};

export default Modal;
